import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalService, MsalInterceptor, MsalGuard, MsalBroadcastService, MsalRedirectComponent } from '@azure/msal-angular';
import { MSALInstanceFactory, MSALGuardConfigFactory, MSALInterceptorConfigFactory } from './app/core/msal/msal.module';
import { APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { routes } from './app/app.routes';
import { BackendResourcesType, AppsettingsConfig } from './app/interfaces/msal-config';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppService } from './app/service/app.service';
import { app_init } from './app_init';
import { HttpHeaderInterceptor } from './app/core/interceptor/http-header.interceptor';
import { HttpErrorInterceptor } from './app/core/interceptor/http-error.interceptor';
import 'moment/locale/it';
import { ErrorHandlerService } from './app/service/error-handler.service';
import { LoggingService } from './app/service/logging.service';
import { provideDesignAngularKit } from 'design-angular-kit';
import { EntiService } from './app/pages/anagrafica-ente/enti.service';
// import * as moment from 'moment';

// moment.locale('it');

export var appsettingsConfig: AppsettingsConfig | null = null;

fetch('api/appsettings').then(async (value) => appsettingsConfig = await value.json()).finally(() => {


  bootstrapApplication(AppComponent,
    {
      providers: [
        // importProvidersFrom(SharedModule),
        provideHttpClient(withInterceptorsFromDi()),
        provideRouter(routes),

        {
          provide: HTTP_INTERCEPTORS,
          useClass: MsalInterceptor,
          multi: true
        },
        {
          provide: MSAL_INSTANCE,
          useFactory: () => MSALInstanceFactory(<AppsettingsConfig>appsettingsConfig)
        },
        {
          provide: MSAL_GUARD_CONFIG,
          useFactory: MSALGuardConfigFactory
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG,
          useFactory: () => MSALInterceptorConfigFactory(<BackendResourcesType>appsettingsConfig?.backendResources),
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        {
          provide: APP_INITIALIZER,
          useFactory: app_init,
          multi: true,
          deps: [MsalService, AppService, EntiService],
        },
        provideAnimations(),
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpHeaderInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpErrorInterceptor,
          multi: true
        },
        LoggingService,
        { provide: ErrorHandler, useClass: ErrorHandlerService},
        provideDesignAngularKit(),
      ]
    },
  ).then(appref => appref.bootstrap(MsalRedirectComponent))
    .catch((err) => console.error(err));
}).catch((err) => document.getElementsByTagName('body')[0].innerHTML = '<h2 class="text-center py-4">Sito in manutenzione</h2>');
